import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchMegaMenuRegionsSaga } from "./fetchMegaMenuRegionsSaga";
import { fetchPCLocationAutocompleteSaga } from "./fetchPCLocationAutocompleteSaga";
import { fetchVRLocationAutocompleteSaga } from "./fetchVRLocationAutocompleteSaga";

export function* watchMegaMenuRegions() {
  yield takeLatest(
    actionTypes.FETCH_MEGAMENU_REGIONS,
    fetchMegaMenuRegionsSaga
  );
}

export function* watchFetchPCLocationAutocomplete() {
  yield takeLatest(
    actionTypes.FETCH_PC_LOCATION_AUTOCOMPLETE,
    fetchPCLocationAutocompleteSaga
  );
}

export function* watchFetchVRLocationAutocomplete() {
  yield takeLatest(
    actionTypes.FETCH_VR_LOCATION_AUTOCOMPLETE,
    fetchVRLocationAutocompleteSaga
  );
}
